import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import {
  BaseSignProvidersComponent
} from "@pages/settings/components/integrations-page/base-sign-providers/base-sign-providers.component";
import {
  ConnectionCardComponent
} from "@pages/settings/components/integrations-page/connection-card/connection-card.component";
import { ConnectionStatusEnum } from "@models/integrations/connection-status.enum";
import { IntegrationConnectionsEnum } from "@models/integrations/integration-connections.enum";
import { DisclaimerComponent } from "@shared/components/commons/disclaimer/disclaimer.component";
import { selectSignConnectionPlaceholder } from "./constants/select-sign-connection-placeholder";
import { ProviderConnectionStatus } from "./model/provider-connection-status";

@Component({
  selector: 'app-sign-integrations-dropdown',
  standalone: true,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    DisclaimerComponent,
    ConnectionCardComponent
  ],
  templateUrl: 'sign-integrations-dropdown.component.html',
  styleUrl: 'sign-integrations-dropdown.component.scss'
})
export class SignIntegrationsDropdownComponent extends BaseSignProvidersComponent {
  @Input() buttonText = 'Send for eSign';
  @Input() isDisabled = false;
  @Input() outerLoading = false;
  @Input('currentProviderConnectionStatus') set currentProviderConnectionStatusSetter(value: ProviderConnectionStatus | null) {
    this.eSignProviderConnections.forEach((providerConnection) => {
      providerConnection.isLoading = false;

      if (value && providerConnection.connectionType == value.connectionType) {
        providerConnection.connectionStatus = value.status;
        this.selectedSignIntegration.set(value.connectionType);
      } else {
        providerConnection.connectionStatus = ConnectionStatusEnum.NotConnected;
      }
    });

    this.isLoading.set(false);
  }

  @Output() send = new EventEmitter<MouseEvent>();

  readonly selectSignConnectionPlaceholder = selectSignConnectionPlaceholder;

  selectedSignIntegration = signal<IntegrationConnectionsEnum | null>(null);

  onSend(event: MouseEvent): void {
    this.send.emit(event);
  }
}
